import { headCell } from "../../modules/table.funcs"
import { COLUMN, FORMATTING, LAYOUT } from "../../modules/constants"

const { border1, left } = FORMATTING
const chair = "Chair"
const member = "Member"

export const createNexusCommitteesHeadersData = props => {
  // console.log('createCommitteesHeadersData props:', props)
  // NB: Any changes to the headCell(id) - the sort value - must be reflected in the CheatSheet headers!!
  const { columns, isCompany, portrait, the350club } = props
  const borderLeft = portrait ? null : border1
  const lse = props.items[0].entity.companyProps.lse
  const getCommitteeHeadCell = ({ id, borderLeft = null, cell, chair = null, member = null, nameOverride = null }) => headCell({
    align: LAYOUT.COMMITTEE.ALIGNMENT,
    borderLeft,
    cell,
    id,
    paddingLeft: LAYOUT.COLUMN_PADDING,
    width: LAYOUT.COMMITTEE.WIDTH,
    // If (committee) nameOverride is "none" then there is no committee
    // else if nameOverride is not null, use this - adding "Chair" or member
    // else, set tooltipTitle to null and default to the LEGEND value
    tooltipTitle: nameOverride === "none" ? "no committee" : nameOverride ? `${chair ?? member} of the ${nameOverride} Committee`: null,
  })

  const cell = {}

  headCell({ align: left, cell, id: isCompany ? COLUMN.OFFICER : COLUMN.COMPANY })
  headCell({ align: left, cell, id: COLUMN.ROLE })
  headCell({ cell, id: COLUMN.TENURE })
  headCell({ cell, id: COLUMN.STAR })

  var nameOverride = lse?.audCo
  getCommitteeHeadCell({ id: COLUMN.COMMITTEE.AUDIT.CHAIRS, cell, borderLeft, nameOverride, chair })
  getCommitteeHeadCell({ id: COLUMN.COMMITTEE.AUDIT.MEMBER, cell, nameOverride, member })

  nameOverride = lse?.remCo
  getCommitteeHeadCell({ id: COLUMN.COMMITTEE.REMUNERATION.CHAIRS, borderLeft, cell, nameOverride, chair })
  getCommitteeHeadCell({ id: COLUMN.COMMITTEE.REMUNERATION.MEMBER, cell, nameOverride, member })

  nameOverride = lse?.nomCo
  getCommitteeHeadCell({ id: COLUMN.COMMITTEE.NOMINATION.CHAIRS, borderLeft, cell, nameOverride, chair })
  getCommitteeHeadCell({ id: COLUMN.COMMITTEE.NOMINATION.MEMBER, cell, nameOverride, member })

  let headCells = []

  for (const [key, value] of Object.entries(columns))
    if (value === true && cell[parseInt(key)])
      headCells.push(cell[parseInt(key)])

  if (the350club && headCells[0].id === COLUMN.STAR) {
    headCells.shift() // Remove the starHead
    headCells[0].paddingLeft = LAYOUT.COLUMN_PADDING // .. and add some padding
  }

  return headCells
}

